module.exports = __webpack_public_path__ + "static/media/Settings.82477d67.svg";